import React from 'react';
import PropTypes from 'prop-types';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMEditMenuTableRow from 'components/dashboard/form/SMEditMenuTableRow';
import reactMixin from 'react-mixin';
import SMConst from 'lib/SMConst';

class SMOSettingMenuView extends React.Component {

  componentDidMount() {
    window.addEventListener('resize', this.editViewSizeToFit.bind(this), false);
    this.editViewSizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.editViewSizeToFit.bind(this), false);
  }

  editViewSizeToFit(e) {
    let $navigationTable = $(this.refs.navigationTable),
        $navigationTableFooter = $(this.refs.navigationTableFooter);

    $navigationTable.outerHeight(this.navigationTableHeight() - $navigationTableFooter.outerHeight());
  }

  tableDidSelectRowAtIndex(rowIndex) {
    location.href = this.props.navigationList[rowIndex].path(this.props.owner.username);
  }

  isUnmarked(uid) {
    const owner = this.props.owner;
    switch (uid) {
      case 'account':
        return owner.has_account ? SMConst.AccessoryType.None : SMConst.AccessoryType.UnMarked;
        break;
      case 'address':
        return owner.has_address ? SMConst.AccessoryType.None : SMConst.AccessoryType.UnMarked;
        break;
      case 'bank_account':
        return owner.has_bank_account ? SMConst.AccessoryType.None : SMConst.AccessoryType.UnMarked;
        break;
      default:
        return SMConst.AccessoryType.None;
        break;
    }
  }

  render() {
    let navigationRows = this.props.navigationList.map(function(navigation, rowIndex) {
      let isCurrent = this.props.selectedRowIndex == rowIndex;
      return <SMEditMenuTableRow
        key={"setting-rowindex-" + rowIndex}
        title={I18n.t(navigation.title)}
        delegate={this}
        rowIndex={rowIndex}
        isCurrent={isCurrent}
        accessoryType={this.isUnmarked(navigation.uid)}
      />;
    }, this);

    return(
      <div className="dashboard-sidecol fl">
        <h2 className="dashboard-title mt25 mb25 ml20">設定</h2>
        <div ref="navigationTable" className="js-scroller dashboard-sidecol__scrollarea">
          <ul>{navigationRows}</ul>
        </div>
      </div>
    );
  }
}
SMOSettingMenuView.propTypes = {
  owner: PropTypes.object.isRequired,
  navigationList: PropTypes.array.isRequired,
  selectedRowIndex: PropTypes.number.isRequired,
};
reactMixin(SMOSettingMenuView.prototype, SMSplitViewMixin);
export default SMOSettingMenuView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/settings/SMOSettingMenuView.jsx